<template>
	<v-container class="pt-6">
		<v-row justify="center">
      <!-- Grupos asignados -->
			<v-col cols="12" sm="6"  md="6" lg="4" v-for="( grupo, i ) in grupos" :key="i">
			  <v-card class="mx-auto shadowCard" @click="verGrupo( grupo )">
			  	<v-card-text class="mb-0">
	  				<v-row>
	  					<v-col cols="9">
	  						<div>
			            <h5 class="mb-0 font-weight-bold text-h6 textPrimary--text" >
			             	{{ grupo.grupo_corto }}
			            </h5>

			            <p class="mb-0 font-weight-bold">
			              <span class="primary--text font-weight-bold">Nivel {{ grupo.id_nivel }} </span> De {{ grupo.hora_inicio }} a {{ grupo.hora_fin }}
			              <br/>
			              <span class="primary--text">{{ grupo.ciclo }}</span>
			            </p>
			          </div>
	  					</v-col>

	  					<v-col cols="2">
		            <v-avatar
			            size="60"
			            color="transparent"
			            rounded
			            class="avatares"
			          >
			            <ul class="feedback" style="text-align: center; align-content: center; align-items: center; justify-content: center; justify-items: center;">
                    <li class="happy active">
                      <div>
                        <svg class="eye left">
                          <use xlink:href="#eye"></use>
                        </svg>
                        <svg class="eye right">
                          <use xlink:href="#eye"></use>
                        </svg>
                      </div>
                    </li>
						      </ul>
			          </v-avatar>
	  					</v-col>
	  				</v-row>
	  			</v-card-text>
	  			<v-card-actions class="pt-0 pl-2 pb-0">
	  			  <p class="pl-2 font-weight-bold">
            	<v-chip v-if="grupo.lunes" small dark 
            		:class="`mr-1 ${ grupo.id_teacher == getUsuarioLMS.id ? 'primary' : 'grey' }`">
			          Lu
			        </v-chip>

			        <v-chip v-if="grupo.martes" small dark 
			        	:class="`mr-1 ${ grupo.id_teacher == getUsuarioLMS.id ? 'primary' : 'grey' }`">
			          Ma
			        </v-chip>

			        <v-chip v-if="grupo.miercoles" small dark 
			        	:class="`mr-1 ${ grupo.id_teacher == getUsuarioLMS.id ? 'primary' : 'grey' }`">
			          Mi
			        </v-chip>

			        <v-chip v-if="grupo.jueves" small dark 
			        	:class="`mr-1 ${ grupo.id_teacher_2 == getUsuarioLMS.id ? 'primary' : 'grey' }`">
			          Ju
			        </v-chip>

			        <v-chip v-if="grupo.viernes" small dark 
			        	:class="`mr-1 ${ grupo.id_teacher_2 == getUsuarioLMS.id ? 'primary' : 'grey' }`">
			          Vi
			        </v-chip>

			        <v-chip v-if="grupo.sabado" small dark 
			        	:class="`mr-1 primary`">
			          Sa
			        </v-chip>

			        <v-chip v-if="grupo.domingo" small dark 
			        	:class="`mr-1 primary`">
			          Do
			        </v-chip>

			        <v-chip v-if="grupo.clase_actual == 1" small dark 
			        	:class="`mr-1 red`">
			          CORRIENDO
			        </v-chip>
            </p>
	  			</v-card-actions>
			  </v-card>
			</v-col>
			
      <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 4" id="eye">
          <path d="M1,1 C1.83333333,2.16666667 2.66666667,2.75 3.5,2.75 C4.33333333,2.75 5.16666667,2.16666667 6,1"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 7" id="mouth">
          <path d="M1,5.5 C3.66666667,2.5 6.33333333,1 9,1 C11.6666667,1 14.3333333,2.5 17,5.5"></path>
        </symbol>
      </svg>
    </v-row>

    <!-- Alertas -->
    <Alerta      v-if="respuestaAlerta" :parametros="parametros"/>
    <Loader      v-if="cargar"          :loader="loader"/>

	</v-container>
</template>
<script>
	// Importar lebrerías
	import { mapGetters, mapActions } from 'vuex'
  const  base64 = require('base-64');

	// Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'

  import SinGrupos           from '@/components/grupos/SinGrupos.vue'
  import Encuesta            from '@/components/grupos/Encuesta.vue'
  import GruoisListAlumnos   from '@/components/grupos/GruoisListAlumnos.vue'

  export default {
  	components:{
  		Alerta,
      Loader,
      SinGrupos,
      Encuesta,
      GruoisListAlumnos
  	},

  	props:[
  		'grupos'
  	],

    data () {
      return {
        parametros:{
          dialogError: false,
          mensaje: '',
          color: ''
        },

	     	respuestaAlerta:false,
        loader: true,
        cargar: false,
      }
    },

    computed:{
      ...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getGrupos', 'getEscuela' ]),
    },


    methods:{
    	...mapActions( 'login', [ 'abrirGrupoTeacher', 'grabarGruposUsuario', 'salirLogin' ]),

      
    	verGrupo( grupo ){
        this.cargar = true
    		this.abrirGrupoTeacher( grupo ).then(response => { 
          this.cargar = false 
        }).catch( error =>{
          this.validarError ( error )
    		}).finally(()=>{ this.cargar = false })
    	},

      validarError ( value ) {
        this.cargar = false 
        if( value.status == 400 || value.status == 500){
          this.parametros.mensaje      = value.body.message
          this.parametros.dialogError  = true 
          this.parametros.color        = '#FF2C2C'
          this.respuestaAlerta = true 
        }
      },

      copiarPortapapeles( ){
        const matricula = this.getUsuarioLMS.usuario
        let   mensaje   = ''

        if( this.getEscuela == 2 ){
          mensaje = 'https://wa.me/+5218120494796?text=Hola,+me+interesa+aprovechar+el+descuento+especial+para+estudiar+inglés.+Me+recomendó+el+alumno+con+matricula+'+matricula
        }else{
          mensaje = 'https://wa.me/+5218120474412?text=Hola,+me+interesa+aprovechar+el+descuento+especial+para+estudiar+inglés.+Me+recomendó+el+alumno+con+matricula+'+matricula
        }

        navigator.clipboard.writeText(mensaje).then(() => {
        }).catch(err => {
          console.log('Something went wrong', err);
        })
      }
    }
  }
</script>
